import SetPassword from "../Components/SetPassword";
import Title from "../Common/Title";
import { Flex } from "@chakra-ui/react";
import { useState, useCallback, useEffect } from "react";
import { useWrapper } from "../Context/WrapperContext";
import { useSignUpProxy } from "../Custom Hooks/useSignUpProxy";
import  useFocusControl  from "../Custom Hooks/useFocusControl";
import Terms from "../Components/Terms";
import { useConfig } from "../Custom Hooks/useConfig";
import { getSettings } from "../getSettings";

export default function Password() {
  const [newPassword, setNewPassword] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [continueButtonName, setContinueButtonName] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const [isTOUed, setIsTOUed] = useState(false);
  const config = useConfig();
  const { decrement } = useWrapper();
  const settings = getSettings();

  const handleCancel = useCallback(() => {
    if (settings.isSignInPolicy) {
      window.location.assign(config.MYSGI_URL);
    } else {
      setIsTOUed(false);
      decrement();
    }
  }, [decrement, settings.isSignInPolicy, config]);

  const ref = useFocusControl(index => index === 1);

  const { createAction, pageLevelError } = useSignUpProxy({
    newPassword,
    reenterPassword,
    isTOUed,
  });

  useEffect(() => {
    if (settings.isSignInPolicy) {
      setTitle("Reset your password");
      setDescription("To protect your account and information, please reset your password. You can use your existing MYSGI password if it meets the new criteria.")
      setContinueButtonName("Continue");
    } else {
      setTitle("Create a password");
      setDescription("Enter the password you'd like to use. We recommend using a longer password for more security.")
      setContinueButtonName("Create Account");
    }
  }, [settings.isSignInPolicy]);

  return (
    <Flex ref={ref}  direction="column" maxW={544} padding={38} mx="auto">
      <Title text={title} />
      <SetPassword
        description={description}
        password={newPassword}
        setPassword={setNewPassword}
        retypePassword={reenterPassword}
        setRetypePassword={setReenterPassword}
        onContinue={createAction.act}
        onCancel={handleCancel}
        pageLevelError={pageLevelError}
        disableContinue={!isTOUed}
        termsElement={
          <Terms
            isTOUed={isTOUed}
            setIsTOUed={setIsTOUed}
          />
        }
        continueButtonName={continueButtonName}
      />
    </Flex>
  );
}
